import React, { useLayoutEffect } from "react";
import { BrookshireBrotherLogoWithTagline } from "../../../../../assets";
import CoreChristmasImage from "../../../../../assets/CorePlanImages/CoreChristmasImage.avif";

import "./christmasclubelection.scss";

const ChristmasClubElection: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="christmas-card-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Christmas Club Election Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>
					<div className="plan-description">
						<span>
							Save after-tax money year-round to receive the funds in a lump sum before Christmas!
							Employees who elect to participate in this program decide how much is withheld per paycheck,
							and in November of each year, participating employees are distributed the funds they saved
							in with no tax penalties.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={CoreChristmasImage} alt="Core christmas plan image" />
				</div>
			</div>
		</div>
	);
};

export default ChristmasClubElection;
